<admin-app-header></admin-app-header>

<div class="rejections-page">
    <div class="container-fluid">
        <!-- Page Header -->
        <div class="page-header">
            <h1>Merchant Rejections</h1>
            <div class="page-header__actions">
                <button (click)="globalService.exportcsv('merchant-rejections')" class="btn btn-secondary">
                    <i class="fa-solid fa-file-csv"></i> Export CSV
                </button>
            </div>
        </div>

        <!-- Summary Stats -->
        <div class="stats-grid">
            <div class="stat-card stat-card--red">
                <div class="stat-card__icon">
                    <i class="fa-solid fa-ban"></i>
                </div>
                <div class="stat-card__content">
                    <span class="stat-card__label">Total Rejections</span>
                    <span class="stat-card__value">{{ getTotalRejections() }}</span>
                </div>
            </div>
            <div class="stat-card stat-card--orange">
                <div class="stat-card__icon">
                    <i class="fa-solid fa-user-xmark"></i>
                </div>
                <div class="stat-card__content">
                    <span class="stat-card__label">Merchant Rejected</span>
                    <span class="stat-card__value">{{ getMerchantRejectedCount() }}</span>
                </div>
            </div>
            <div class="stat-card stat-card--purple">
                <div class="stat-card__icon">
                    <i class="fa-solid fa-clock"></i>
                </div>
                <div class="stat-card__content">
                    <span class="stat-card__label">Expired (Timed Out)</span>
                    <span class="stat-card__value">{{ getExpiredCount() }}</span>
                </div>
            </div>
            <div class="stat-card stat-card--blue">
                <div class="stat-card__icon">
                    <i class="fa-solid fa-filter"></i>
                </div>
                <div class="stat-card__content">
                    <span class="stat-card__label">Filtered Results</span>
                    <span class="stat-card__value">{{ filteredSubscriptions?.length || 0 }}</span>
                </div>
            </div>
        </div>

        <!-- Filter Bar -->
        <div class="filter-bar">
            <div class="filter-bar__left">
                <div class="filter-search">
                    <i class="fa-solid fa-magnifying-glass"></i>
                    <input (input)="searchKeydown($event)" class="filter-input" placeholder="Search by client, portfolio, parking, or reason..." />
                </div>
                <div class="status-toggle">
                    <button class="toggle-btn" 
                            [class.active]="statusFilter === 'all'" 
                            (click)="setStatusFilter('all')">
                        <i class="fa-solid fa-globe"></i> All
                    </button>
                    <button class="toggle-btn" 
                            [class.active]="statusFilter === 'merchantRejected'" 
                            (click)="setStatusFilter('merchantRejected')">
                        <i class="fa-solid fa-user-xmark"></i> Rejected
                    </button>
                    <button class="toggle-btn" 
                            [class.active]="statusFilter === 'expired'" 
                            (click)="setStatusFilter('expired')">
                        <i class="fa-solid fa-clock"></i> Expired
                    </button>
                </div>
            </div>
            <div class="filter-bar__right">
                <span class="results-count">{{ filteredSubscriptions?.length || 0 }} results</span>
            </div>
        </div>

        <!-- Empty State -->
        <div class="empty-state" *ngIf="!filteredSubscriptions || filteredSubscriptions.length === 0">
            <i class="fa-solid fa-ban"></i>
            <h3>No Rejections Found</h3>
            <p>There are no rejections matching your current filters.</p>
        </div>

        <!-- Rejections Table -->
        <div class="table-card" *ngIf="filteredSubscriptions && filteredSubscriptions.length > 0">
            <table class="rejections-table" id="merchant-rejections">
                <thead>
                    <tr>
                        <th *ngFor="let column of columns"
                            [class.sortable]="column.sortable"
                            [class.sorted]="isColumnSorted(column.key)"
                            (click)="column.sortable ? sortByColumn(column.key) : null">
                            {{ column.label }}
                            <i *ngIf="column.sortable && column.key" [class]="getSortIcon(column.key)"></i>
                        </th>
                    </tr>
                </thead>
                <tbody>
                    <tr *ngFor="let subscription of filteredSubscriptions" class="rejection-row">
                        <!-- Created -->
                        <td>
                            <a [routerLink]="['/admin/subscription', subscription.$key]" class="date-link">
                                {{ subscription.createdAt | formatDate }}
                            </a>
                        </td>

                        <!-- Status -->
                        <td>
                            <span class="status-badge" 
                                  [class.status-badge--rejected]="subscription.status === ContractStatus.merchantRejected"
                                  [class.status-badge--expired]="subscription.status === ContractStatus.expired">
                                {{ subscription.statusNiceName }}
                            </span>
                        </td>

                        <!-- Client -->
                        <td>
                            <ng-container *ngIf="subscription.clientRef">
                                <a [routerLink]="['/', AngularRoutes.client, subscription.clientRef.id]" 
                                   class="entity-link"
                                   [class.undefined]="!subscription.denormClientFirstName"
                                   title="{{ getFullNameFromSubscription(subscription) }}">
                                    {{ getFullNameFromSubscription(subscription) | truncate:[30] }}
                                </a>
                            </ng-container>
                            <span *ngIf="!subscription.clientRef" class="missing-badge">
                                <i class="fa-solid fa-exclamation-triangle"></i> Missing
                            </span>
                        </td>

                        <!-- Portfolio -->
                        <td>
                            <ng-container *ngIf="subscription.merchantRef">
                                <a [routerLink]="['/', AngularRoutes.MERCHANT, subscription.merchantRef.id]" 
                                   class="entity-link"
                                   [class.undefined]="!subscription.denormMerchantCompanyName">
                                    {{ subscription.denormMerchantCompanyName || 'Undefined' | truncate:[30] }}
                                </a>
                            </ng-container>
                            <span *ngIf="!subscription.merchantRef" class="missing-badge">
                                <i class="fa-solid fa-exclamation-triangle"></i> Missing
                            </span>
                        </td>

                        <!-- Parking -->
                        <td>
                            <ng-container *ngIf="subscription.parkingRef">
                                <a [routerLink]="['/', AngularRoutes.parking, subscription.parkingRef.id]" 
                                   class="entity-link"
                                   [class.undefined]="!subscription.denormParkingTitle">
                                    {{ subscription.denormParkingTitle || 'Undefined' | truncate:[40] }}
                                </a>
                            </ng-container>
                            <span *ngIf="!subscription.parkingRef" class="missing-badge">
                                <i class="fa-solid fa-exclamation-triangle"></i> Missing
                            </span>
                        </td>

                        <!-- Rejection Reason -->
                        <td>
                            <span *ngIf="subscription.status === ContractStatus.expired" class="reason-text reason-text--expired">
                                <i class="fa-solid fa-clock"></i> Automatically timed out after 24 hours
                            </span>
                            <span *ngIf="subscription.status === ContractStatus.merchantRejected" class="reason-text">
                                {{ subscription.rejectionReason || 'No reason provided' }}
                            </span>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
</div>
